/**
 * BackToTop — botão flutuante "voltar ao topo" (todas as páginas).
 *
 * Aparece após rolar ~400px. Registrado via config.settings.appExtras.
 * Respeita prefers-reduced-motion (scroll instantâneo).
 */
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'clsx';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import chevronUpSVG from '../../icons/chevron-up.svg';

const messages = defineMessages({
  backToTop: {
    id: 'footer.backToTop',
    defaultMessage: 'Back to top',
  },
});

const SCROLL_THRESHOLD = 400; // px

const BackToTop = () => {
  const intl = useIntl();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    const reduced = window.matchMedia?.(
      '(prefers-reduced-motion: reduce)',
    )?.matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  };

  return (
    <button
      type="button"
      className={cx('back-to-top', { 'back-to-top--visible': visible })}
      onClick={scrollToTop}
      aria-label={intl.formatMessage(messages.backToTop)}
      tabIndex={visible ? 0 : -1}
    >
      <Icon name={chevronUpSVG} size="24px" />
    </button>
  );
};

export default BackToTop;
